export enum SubscriptionStatus {
  active = "active",
  trialing = "trialing",
  past_due = "past_due",
  canceled = "canceled",
  unpaid = "unpaid",
  paused = "paused",
  incomplete = "incomplete",
  incomplete_expired = "incomplete_expired",
  unknown = "unknown",
  none = "none",
}
